import Vue from 'vue'
import Router from 'vue-router'
import Login from "./login/login"
import Form from "./form/form"

Vue.use(Router)
let routes = [
  {path: '/', component: Login},
  {path: '/enquete/:place/:code', component: Login},
  {path: '/enquete/:place', component: Form},
  {path: '/form/:formId', component: Form},
  {path: '/form/:place/:formId', component: Form},
];

let router = new Router({
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
});


router.beforeEach(function (to, from, next) {
  let place = null;
  let code = null;
  if (to.params['place'] !== undefined) {
    place = to.params['place'];
    window.localStorage.setItem("place", place);
  }
  if (to.params['code'] !== undefined) {
    code = to.params['code'];
    window.localStorage.setItem("code", code);
  }

  let privateRoutes = ["/meus-cupons"];
  let logado = (router.app.client && router.app.client.id) ? true : false;
  let token = null;
  if (logado) {
    if (router.app.client.token) {
      token = router.app.client.token;
    }
    if (privateRoutes.indexOf(to.path) !== -1 && !token) {
      logado = false;
    }
  }

  let publicRoutes = ["", "/reset-password/:code","/form/:place/:formId"];
  let currentRoute = to.matched[0].path;

  if (publicRoutes.indexOf(currentRoute) === -1 && !logado) {
    if (!code) {
      code = window.localStorage.getItem("code");
    }
    if (!place) {
      place = window.localStorage.getItem("place");
    }
    next({
      path: '/',
      query: {
        redirect: to.fullPath,
        place: place,
        code: code
      },
    });
  } else {
    window.mixpanel?.track("Page visit", {"page": to.path, "fullPath": to.fullPath, "params": to.params});
    next();
  }
});

export default router;